<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter">
<h3 class="firstInSection">Letter found among Cato’s papers and preserved in the archives of Rome. The hand was crude, the grammar poor and the Latin strange. But it is reproduced here as faithfully as my papyrology allows</h3>
<p><em>My wife.</em> I hope this will finds you well, if as is it finds you at all which I am not sure of. The wind has been from the north now these past days, and seeing as you know that do not agree with my bones. The word is how the Eastern Fleet has stepped up its patrols. No one knows why. They are searching every ship, they say, and intercepting mail. It’s like when that devil Hannibal was loose, but I’m sure as they will have done for him by now. For me, I am earning a living as best as what I know how. Never could be doing with all those registrars they introduced those years back under whatever they as called those new laws. I always were a man for attitude, and you know mine. There’s the <em>Apollodorus</em> to recaulk this winter, and she needs new sails. I said when last I written that I was of a mind, grant Neptune, to be safe home with you for the festival of Cybele. We made our journey with our passengers like what I wrote to you we would, but then I did set off on another one with one of them alone and now he wants me to take him on another one, though he won’t say where but the money’s good and real. I should know. Near broke a tooth on it. If we go south as I suspects, I’ll bring you home a parakeet, and anyhows I’ll see you in a while. I hopes the cows are in good milk, and all the kids are well. <em>Your husband, Trimalchio</em>.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter9.vue?dc7cdfee